import { render, staticRenderFns } from "./SubCommunityNutPower.vue?vue&type=template&id=4f1bb31f&scoped=true&"
import script from "./SubCommunityNutPower.vue?vue&type=script&lang=js&"
export * from "./SubCommunityNutPower.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityNutPower.vue?vue&type=style&index=0&id=4f1bb31f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1bb31f",
  null
  
)

export default component.exports